import request from 'utils/request'

// 添加
export const add = data => request().post('accountPeriod/add', data)
// 删除
export const getTableData = data =>
  request().post('accountPeriod/select', data)

// // 添加
// export const add = data => request().post('accountPeriod/add', data)

// // 删除
// export const remove = id => request().post(`accountPeriod/delete/${id}`)

// 编辑
// export const update = data => request().post('accountPeriod/update', data)

// 获取列表数据
// export const getTableData = data => request().post('accountPeriod/page', data)

/**
 * 获取业务类型列表
 */
export const getBusinessList = () => request().get('business/list')

/**
 * 获取法人主体列表
 */
export const getLegalList = () => request().get('customer/legal/list')

/**
 * 获取 大区 | 业务模式 | 信控区列表
 */
export const getRegionList = data =>
  request().post('business/region/list', data)

export const getSegmentLevelList = data =>
  request().post('sysSegment/segmentLevel/list', data)
  
// 获取业务模式冻结列表
export const getFreezeModelList = () =>
  request().get('business/jsonList/getFreezeModelList')

//获取Segment冻结列表
export const getFreezeSegmentList = () =>
  request().get('sysSegment/getFreezeSegmentList')

// 获取业务类型冻结列表
export const getFreezeBgList = () =>
  request().get('business/jsonList/getFreezeBgList')

/**
 * 获取Segment列表
 */
export const getSegmentList = business =>
  request().post(`sysSegment/group/${business}`)
/**
 * 获取BG下拉列表
 */
export const getBgList = () => request().get('business/list')
//根据business查name
export const selectName = business =>
  request().post(`business/selectName/${business}`)
//根据segment查segmentLevel
export const selectLevel = segment =>
  request().post(`sysSegment/selectLevel/${segment}`)
